import Image from 'next/image';
import useLocale from 'next-translate/useTranslation';

const people = [
  {
    name: 'Entrepreneur',
    imageUrl: 'https://media.easy-peasy.ai/static/workshop/Entrepreneur.jpg',
    bio: 'Passionate about turning innovative ideas into successful businesses. Seeking opportunities for constant passive income to fuel growth and expansion.',
  },
  {
    name: 'Influencer',
    imageUrl: 'https://media.easy-peasy.ai/static/workshop/Influencer.jpg',
    bio: 'Creating content that resonates and builds a loyal following. Interested in monetizing influence through passive income streams.',
  },
  {
    name: 'Digital Marketer and SMM',
    imageUrl: 'https://media.easy-peasy.ai/static/workshop/Marketer.jpg',
    bio: 'Expert in driving online engagement and sales. Looking for passive income opportunities to leverage digital marketing skills.',
  },
  {
    name: 'Agencies, Freelancers, and Consultants',
    imageUrl: 'https://media.easy-peasy.ai/static/workshop/Agencies.jpg',
    bio: 'Providing top-tier services and solutions. Interested in diversifying income through passive revenue streams.',
  },

  // More people...
];

export default function Example() {
  const { t } = useLocale('affiliates');

  return (
    <div className='bg-white py-24 dark:bg-slate-800 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='mx-auto max-w-2xl sm:text-center'>
          <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Is this Affiliate Program for me?')}
          </h2>
          <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-slate-400'>
            {t('Discover if our affiliate program aligns with your goals')}
          </p>
        </div>
        <ul
          role='list'
          className='mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-6 gap-y-20 sm:grid-cols-2 lg:max-w-4xl lg:gap-x-8 xl:max-w-none'
        >
          {people.map((person) => (
            <li key={person.name} className='flex flex-col gap-6 xl:flex-row'>
              <Image
                className='aspect-[4/5] w-52 flex-none rounded-2xl object-cover'
                src={person.imageUrl as string}
                width='208'
                height='260'
                alt=''
              />
              <div className='flex-auto'>
                <h3 className='text-lg font-semibold leading-8 tracking-tight text-gray-900 dark:text-slate-200'>
                  {t(person.name)}
                </h3>
                <p className='mt-6 text-base leading-7 text-gray-600 dark:text-slate-400'>
                  {t(person.bio)}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
